export const dataHooks = {
  carouselWIPCount: 'carouselWIP-count',
  carouselWIPButton: 'carouselWIP-button',
};

export const CONTROLS_START_END = {
  DISABLED: 'disabled',
  HIDDEN: 'hidden',
};

export const SLIDING_TYPE = {
  ALIGN_TO_START: 'align-to-start',
  REVEAL_ONE: 'reveal-one',
  REVEAL_CHUNK: 'reveal-chunk',
};

export const ALIGNMENT = {
  LEFT: 'left',
  RIGHT: 'right',
};

export const SKIN_PRIORITY_MAP = {
  standard: 'secondary',
  inverted: 'primary',
  light: 'primary',
  transparent: 'primary',
  premium: 'primary',
};

export const DATA_HOOKS = {
  loader: 'loader',
  imagesContainer: 'images-container',
  carouselImage: 'carousel-img',
  prevButton: 'prev-button',
  nextButton: 'next-button',
  child: 'carousel-child',
  pageNavigation: index => `page-navigation-${index}`,
};

export const AUTOPLAY_SPEED = 2000;
